<div class="container-fluid p-0">
  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
    <div class="card rounded-0">
      <div class="card-body">

        <div class="row pt-3">
          <div class="col-12 col-xl-6">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Address / Address Lookup</mat-label>
              <input
                matInput
                placeholder="Address / Address Lookup"
                [(ngModel)]="site.location"
                (ngModelChange)="onAddressInputChange($event)"
                [matAutocomplete]="addressAuto"
                name="location"
                id="location"
                #location
                type="text"
                required/>
              <mat-autocomplete #addressAuto="matAutocomplete">
                <mat-option
                  *ngFor="let prediction of addressPredictions"
                  [value]="prediction.label"
                  (onSelectionChange)="$event.isUserInput && onSelectPrediction(prediction)">
                  {{ prediction.label }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="!location.valid">
                Please enter a location / physical address.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-xl-6">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Max Geofence Size</mat-label>
              <input
                matInput
                placeholder="Max Geofence Size"
                [(ngModel)]="site.max_geofence_size"
                name="max_geofence_size"
                type="number"
                id="max_geofence_size"/>
              <mat-hint>Enter max geofence size here.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">

            <small>
              Use the map below to draw a geofence. Click points on the map to outline the area, then drag the points to fine tune it. The default max geofence size is 50000 m2.
            </small>

            <div #map id="map" appMarginTop></div>

            <small><b>Allowed Geofence Size:</b> {{ site.max_geofence_size }} &#13217; | <b>Current Size:</b> {{ site.geofence_size | number: '1.0-0' }} &#13217;</small>

          </div>
        </div>

        <div class="row mt-2">
          <div class="col">

            <button
              mat-raised-button
              [disabled]="!f.valid || inProgress || site.geofence_size > site.max_geofence_size"
              (click)="onSubmit(f)"
              type="button"
              color="primary"
              class="my-2 ml-0 mr-2">
              <mat-icon>save</mat-icon> Save
            </button>

            <button
              mat-raised-button
              type="button"
              (click)="resetMapControls()"
              color="secondary"
              class="my-2 ml-0 mr-2">
              <mat-icon>restore</mat-icon> Reset Map
            </button>

          </div>
        </div>

      </div>
    </div>
  </form>
</div>
